import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { VisitDetailPhotos } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { catchError, Observable, throwError } from 'rxjs';

export class ExamPhotosEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  get(visitId: number): Observable<VisitDetailPhotos.ExamPhotoResponse> {
    return this.http
      .get<VisitDetailPhotos.ExamPhotoResponse>(
        `${this.env.constants.ADMIN_API_URL}/admin/orders/${visitId}/visitphotos?polling=true`,
      )
      .pipe(catchError((err: HttpErrorResponse) => throwError(() => new Error(err.message))));
  }
}
